export const RESET_PASSWORD_EMAIL = 'Email'
export const RESET_PASSWORD_SMS = 'Sms'
export const RESET_PASSWORD_SETTING = 'Setting'
